import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";

/**
 * API - 全局通用 API
 * @date: 2018-6-20
 * @author: niujiaqing <njq.niu@hand-china.com>
 * @version: 0.0.1
 * @copyright Copyright (c) 2018, Hand
 */
import request from "../../utils/request";
import { getEnvConfig } from "../../utils/iocUtils";
import { getCurrentOrganizationId, getCurrentRole, getResponse // isTenantRoleLevel,
, isEqualOrganization } from "../../utils/utils";
var _getEnvConfig = getEnvConfig(),
  HZERO_IAM = _getEnvConfig.HZERO_IAM,
  HZERO_PLATFORM = _getEnvConfig.HZERO_PLATFORM,
  HZERO_MNT = _getEnvConfig.HZERO_MNT,
  TOP_MENU_LABELS = _getEnvConfig.TOP_MENU_LABELS,
  TOP_MENU_UNION_LABEL = _getEnvConfig.TOP_MENU_UNION_LABEL; // primary 私有的api(组件, 页面无关的api)

/**
 * 查询菜单.
 * {HZERO_IAM}/hzero/v1/menus/tree
 * @param {object} query - 现在菜单会包含语言
 */
export function queryMenu() {
  return _queryMenu.apply(this, arguments);
}
/**
 * 查询平台多语言国际化
 * {HZERO_PLATFORM}/v1/{organizationId}/prompt/{language}
 * @param {Number} organizationId
 * @param {String} language
 * @param {String} promptKey - 这里只用到了 hzero.common
 */

function _queryMenu() {
  _queryMenu = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var query,
      role,
      params,
      _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            query = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
            role = getCurrentRole();
            params = TOP_MENU_LABELS && TOP_MENU_LABELS !== 'undefined' ? _objectSpread({}, query, {
              roldId: role.id,
              labels: TOP_MENU_LABELS,
              unionLabel: TOP_MENU_UNION_LABEL === 'undefined' ? false : TOP_MENU_UNION_LABEL || false
            }) : _objectSpread({}, query, {
              roldId: role.id,
              unionLabel: TOP_MENU_UNION_LABEL === 'undefined' ? false : TOP_MENU_UNION_LABEL || false
            });
            return _context.abrupt("return", request("".concat(HZERO_IAM, "/hzero/v1/menus/tree"), {
              method: 'GET',
              query: params
            }));
          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _queryMenu.apply(this, arguments);
}
export function queryPromptLocale(_x, _x2, _x3) {
  return _queryPromptLocale.apply(this, arguments);
}
/**
 * public路由下查询平台多语言国际化
 * {HZERO_PLATFORM}/v1/{organizationId}/prompt/{language}
 * @param {Number} organizationId
 * @param {String} language
 * @param {String} promptKey - 这里只用到了 hzero.common
 */

function _queryPromptLocale() {
  _queryPromptLocale = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(organizationId, language, promptKey) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", request("".concat(HZERO_PLATFORM, "/v1/").concat(organizationId, "/prompt/").concat(language, "?promptKey=").concat(promptKey)));
          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _queryPromptLocale.apply(this, arguments);
}
export function queryPublicPromptLocale(_x4, _x5) {
  return _queryPublicPromptLocale.apply(this, arguments);
}
/**
 * 查询 LOV 配置.
 * {HZERO_PLATFORM}/v1/lov-view/info
 * @param {Object} params 参数
 */

function _queryPublicPromptLocale() {
  _queryPublicPromptLocale = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(language, promptKey) {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", request("".concat(HZERO_PLATFORM, "/v1/prompt/").concat(language, "?promptKey=").concat(promptKey)));
          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _queryPublicPromptLocale.apply(this, arguments);
}
export function queryLov(_x6) {
  return _queryLov.apply(this, arguments);
}
/**
 * 查询 LOV 数据.
 * @param {string} url URL
 * @param {Object} params 参数
 */

function _queryLov() {
  _queryLov = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(params) {
    var publicMode, otherParams, res;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            publicMode = params.publicMode, otherParams = _objectWithoutProperties(params, ["publicMode"]);
            res = request("".concat(HZERO_PLATFORM, "/v1/").concat(
            // eslint-disable-next-line no-nested-ternary
            publicMode ? 'pub/' : isEqualOrganization() ? "".concat(getCurrentOrganizationId(), "/") : '', "lov-view/info"), {
              method: 'GET',
              query: otherParams
            }); // FIXME: @WJC utils need fix
            // @ts-ignore

            return _context4.abrupt("return", getResponse(res));
          case 3:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _queryLov.apply(this, arguments);
}
export function queryLovData(_x7, _x8, _x9) {
  return _queryLovData.apply(this, arguments);
}
/**
 * 查询 LOV 配置.
 * {HZERO_PLATFORM}/v1/lov-view/info
 * @param {Object} params 参数
 */

function _queryLovData() {
  _queryLovData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(url, params, method) {
    var options, res;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            options = {};
            if (method) {
              options.method = method.toUpperCase();
              if (method.toUpperCase() !== 'GET') {
                options.body = params;
              } else {
                options.query = params;
              }
            } else {
              options.query = params;
            }
            res = request(url, options); // FIXME: @WJC utils need fix
            // @ts-ignore

            return _context5.abrupt("return", getResponse(res));
          case 4:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _queryLovData.apply(this, arguments);
}
export function recordLov(_x10) {
  return _recordLov.apply(this, arguments);
}
/**
 * 查询动态表格
 * @param {object} query
 * @returns {Promise<void>}
 */

function _recordLov() {
  _recordLov = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(params) {
    var res;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            res = request("".concat(HZERO_PLATFORM, "/v1/").concat(
            // eslint-disable-next-line no-nested-ternary
            isEqualOrganization() ? "" : '', "lov-view/select-value/record"), {
              method: 'POST',
              body: params
            }); // FIXME: @WJC utils need fix
            // @ts-ignore

            return _context6.abrupt("return", getResponse(res));
          case 2:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _recordLov.apply(this, arguments);
}
export function queryUiTables() {
  return _queryUiTables.apply(this, arguments);
}
/**
 * 查询动态表格
 * @param {object} query
 * @returns {Promise<void>}
 */

function _queryUiTables() {
  _queryUiTables = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
    var query,
      organizationId,
      _args7 = arguments;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            query = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : {};
            organizationId = getCurrentOrganizationId();
            return _context7.abrupt("return", request("".concat(HZERO_PLATFORM, "/v1/").concat(organizationId, "/ui-table"), {
              method: 'GET',
              query: query
            }));
          case 3:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _queryUiTables.apply(this, arguments);
}
export function queryHistoryData(_x11) {
  return _queryHistoryData.apply(this, arguments);
} // primary 私有的api(组件, 页面无关的api)

/**
 * 变更用户的默认菜单布局选项
 * @async
 * @function updateDefaultMenu
 * @param {!string} params.
 * @returns fetch Promise
 */

function _queryHistoryData() {
  _queryHistoryData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(query) {
    var organizationId, url;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            organizationId = getCurrentOrganizationId();
            url = "".concat(HZERO_MNT, "/v1/").concat(organizationId, "/audit-documents/log/detail");
            return _context8.abrupt("return", request(url, {
              method: 'GET',
              query: query
            }));
          case 3:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _queryHistoryData.apply(this, arguments);
}
export function updateDefaultMenu(_x12) {
  return _updateDefaultMenu.apply(this, arguments);
}
function _updateDefaultMenu() {
  _updateDefaultMenu = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(params) {
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            return _context9.abrupt("return", request("".concat(HZERO_IAM, "/hzero/v1/users/config-items"), {
              method: 'PUT',
              query: _objectSpread({}, params)
            }));
          case 1:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
  return _updateDefaultMenu.apply(this, arguments);
}